export const STATUS_OPTIONS = [
    { label: 'Open', value: 'open' },
    { label: 'In Progress', value: 'in_progress' },
    { label: 'On Hold', value: 'on_hold' },
    { label: 'Resolved', value: 'resolved' },
    { label: 'Closed', value: 'closed' },
];

export const PRIORITY_OPTIONS = [
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
    { label: 'High', value: 'high' },
    { label: 'Urgent', value: 'urgent' },
];

export const CATEGORY_OPTIONS = [
    { label: 'Bug', value: 'bug' },
    { label: 'Technical', value: 'technical' },
    { label: 'Incident', value: 'incident' },
    { label: 'Feature Request', value: 'feature_request' },
    { label: 'Other', value: 'other' },
];

export const SOURCE_LABELS = {
    user_reported: 'User Reported',
    system_generated: 'System Generated',
};

const statusClassMap = {
    open: 'hd-badge-open',
    in_progress: 'hd-badge-progress',
    on_hold: 'hd-badge-hold',
    resolved: 'hd-badge-resolved',
    closed: 'hd-badge-closed',
};

const priorityClassMap = {
    low: 'hd-badge-low',
    medium: 'hd-badge-medium',
    high: 'hd-badge-high',
    urgent: 'hd-badge-urgent',
};

export function statusLabel(value) {
    return STATUS_OPTIONS.find(o => o.value === value)?.label || value || '—';
}

export function priorityLabel(value) {
    return PRIORITY_OPTIONS.find(o => o.value === value)?.label || value || '—';
}

export function categoryLabel(value) {
    return CATEGORY_OPTIONS.find(o => o.value === value)?.label || value || '—';
}

export function statusBadgeClass(value) {
    return `hd-badge ${statusClassMap[value] || 'hd-badge-default'}`;
}

export function priorityBadgeClass(value) {
    return `hd-badge ${priorityClassMap[value] || 'hd-badge-default'}`;
}

export function formatDateTime(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric',
        hour: 'numeric', minute: '2-digit',
    });
}

export function formatFileSize(bytes) {
    if (bytes === null || bytes === undefined) return '—';
    const n = Number(bytes);
    if (Number.isNaN(n)) return '—';
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function resolveUserName(id, usersList) {
    if (!id) return '—';
    const u = usersList?.find(u => u.value === id);
    return u ? `${u.label} (#${id})` : `User #${id}`;
}
